import React, { useState, Children } from 'react';
import { Search, MapPin, ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
import { Logo } from '../components/Logo';
interface HomeProps {
  onItemClick: (id: string) => void;
  onBrowseNearby: () => void;
  onCategoryClick: (category: string) => void;
}
export function Home({
  onItemClick,
  onBrowseNearby,
  onCategoryClick
}: HomeProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const categories = [{
    name: 'Tools',
    icon: '🔧'
  }, {
    name: 'Baby Gear',
    icon: '👶'
  }, {
    name: 'Party',
    icon: '🎉'
  }, {
    name: 'Outdoors',
    icon: '⛺'
  }, {
    name: 'Sports',
    icon: '⚽'
  }, {
    name: 'Electronics',
    icon: '📱'
  }, {
    name: 'Kitchen',
    icon: '🍳'
  }, {
    name: 'Lawn Care',
    icon: '🌱'
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <div className="min-h-screen bg-cream pb-24" data-id="element-1154">
      {/* Header */}
      <div className="bg-white border-b border-sand sticky top-0 z-10" data-id="element-1155">
        <div className="max-w-md mx-auto px-4 pt-4 pb-3" data-id="element-1156">
          <div className="flex items-center justify-between mb-4" data-id="element-1157">
            <Logo variant="full" size="md" data-id="element-1158" />
            <button className="flex items-center gap-1 text-sm text-charcoal" data-id="element-1159">
              <MapPin size={16} className="text-dark-green" data-id="element-1160" />
              <span className="font-medium" data-id="element-1161">San Francisco</span>
              <ChevronDown size={16} data-id="element-1162" />
            </button>
          </div>

          {/* Search Bar */}
          <div className="relative" data-id="element-1163">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-moss-gray" size={20} data-id="element-1164" />
            <input type="text" placeholder="I want to borrow..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-11 pr-4 py-3 bg-cream rounded-ios text-charcoal placeholder-moss-gray focus:outline-none focus:ring-2 focus:ring-dark-green" data-id="element-1165" />
          </div>
        </div>
      </div>

      <div className="max-w-md mx-auto px-4 py-6 space-y-6" data-id="element-1166">
        {/* Browse Nearby CTA */}
        <motion.button initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} whileTap={{
        scale: 0.98
      }} onClick={onBrowseNearby} className="w-full py-4 bg-dark-green text-white rounded-ios-lg shadow-ios active:shadow-none transition-shadow flex items-center justify-center gap-2" data-id="element-1167">
          <MapPin size={20} data-id="element-1168" />
          <span className="text-base font-semibold" data-id="element-1169">Browse Nearby</span>
        </motion.button>

        {/* Category Grid */}
        <div data-id="element-1170">
          <h2 className="text-lg font-semibold text-charcoal mb-4" data-id="element-1171">
            Browse by Category
          </h2>
          <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-2 gap-3" data-id="element-1172">
            {categories.map(category => <motion.button key={category.name} variants={item} whileTap={{
            scale: 0.98
          }} onClick={() => onCategoryClick(category.name)} className="aspect-square bg-white border-2 border-sand rounded-ios-lg shadow-ios active:shadow-none transition-shadow flex flex-col items-center justify-center gap-3 p-4" data-id="element-1173">
                <span className="text-4xl" data-id="element-1174">{category.icon}</span>
                <span className="text-sm font-semibold text-charcoal text-center" data-id="element-1175">
                  {category.name}
                </span>
              </motion.button>)}
          </motion.div>
        </div>
      </div>
    </div>;
}